import { Routes } from '@datadog/browser-rum-react/react-router-v6';
import { i18n } from '@lingui/core';
import { I18nProvider } from '@lingui/react';
import { Trans } from '@lingui/react/macro';
import { Route } from 'react-router-dom';

import Admin from '../Admin/Admin';
import { BankLinkPreview } from '../components/BankLinkPreview/BankLinkPreview';
import Branding from '../components/Branding/Branding';
import { ErrorBoundary } from '../components/ErrorBoundary/ErrorBoundary';
import { GenericError } from '../components/GenericError/GenericError';
import { GenericLayout } from '../components/Layout/GenericLayout/GenericLayout';
import { SignupLayout } from '../components/Layout/SignupLayout/SignupLayout';
import { ShareLinkOpenBanking } from '../components/ShareLinkOpenBanking/ShareLinkOpenBanking';
import SignupRoutesDE from '../components/SignupRoutes/SignupRoutesDE/SignupRoutesDE';
import SignupRoutesUK from '../components/SignupRoutes/SignupRoutesUK/SignupRoutesUK';
import StepRouterDE from '../components/StepRouter/StepRouterDE/StepRouterDE';
import StepRouterUK from '../components/StepRouter/StepRouterUK/StepRouterUK';
import { Connect } from '../Connect/Connect';
import { useEnvProxyForLocale } from '../DeveloperTooling/useEnvProxyForLocale';
import { SignupProvider } from '../hooks/useSignup';
import { messages as deMessages } from '../locales/de/messages';
import { messages as enMessages } from '../locales/en-GB/messages';
import { isIwocaDE } from '../utils/countryHelper';
import { DE_LOCALE, UK_LOCALE } from '../utils/i18n';
import { initialiseTracking } from '../utils/trackingSetup.helpers';

const locale = isIwocaDE() ? DE_LOCALE : UK_LOCALE;

i18n.load({
  [UK_LOCALE]: enMessages,
  [DE_LOCALE]: deMessages,
});
i18n.activate(locale);

export const App = () => {
  initialiseTracking();
  useEnvProxyForLocale();

  return (
    <I18nProvider i18n={i18n}>
      <ErrorBoundary>
        <Routes>
          <Route path="/admin/*" element={<Admin />} />
          <Route path="/connect/*" element={<Connect />} />
          {locale === 'en-GB' && (
            <Route
              path="/link-open-banking/*"
              element={
                <GenericLayout>
                  <ShareLinkOpenBanking />
                </GenericLayout>
              }
            />
          )}
          <Route
            path="/:affiliateTag/preview-link-bank"
            element={
              <SignupProvider>
                <BankLinkPreview />
              </SignupProvider>
            }
          />
          <Route
            path="/:affiliateTag/*"
            element={
              <SignupProvider>
                <Branding>
                  <SignupLayout>
                    {locale === 'de' ? (
                      <StepRouterDE>
                        <SignupRoutesDE />
                      </StepRouterDE>
                    ) : (
                      <StepRouterUK>
                        <SignupRoutesUK />
                      </StepRouterUK>
                    )}
                  </SignupLayout>
                </Branding>
              </SignupProvider>
            }
          />
          <Route
            path="/*"
            element={
              <GenericError errorText={<Trans>Page not found.</Trans>} />
            }
          />
        </Routes>
      </ErrorBoundary>
    </I18nProvider>
  );
};
